import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'gatsby-plugin-intl'
import ProjectModal from 'components/ProjectModal'
import usePortal from 'hooks/usePortal'
import * as S from './ProjectCard.styles'
import useTranslate from 'hooks/useTranslate'
import placeholderEN from 'assets/images/projects/placeholderEN.jpg'
import placeholderPT from 'assets/images/projects/placeholderPT.jpg'

const imgPlaceholder = {
  pt: placeholderPT,
  en: placeholderEN,
}

const ProjectCard = ({ title, description, imgUrl }) => {
  const { formatMessage, locale } = useIntl(0)
  const [showModal, setShowModal] = useState(false)
  const [showDescription, setShowDescription] = useState(false)
  const Portal = usePortal('portal')
  const translate = useTranslate()

  return (
    <>
      <S.Wrapper
        show={showDescription}
        onClick={() => setShowDescription(!showDescription)}
      >
        <S.Content>
          <S.Top
            style={{
              backgroundImage: `url(${
                imgUrl === undefined ? imgPlaceholder[locale] : imgUrl
              })`,
            }}
          />
          <S.Bottom>
            <S.Title>{translate(title)}</S.Title>
            <S.VerMais outline onClick={() => setShowModal(true)}>
              {formatMessage({ id: 'projects.seeMore' })}
            </S.VerMais>
          </S.Bottom>
        </S.Content>
      </S.Wrapper>
      <Portal>
        <ProjectModal
          imgUrl={imgUrl}
          title={title}
          description={description}
          alt={title}
          show={showModal}
          handleClose={() => setShowModal(false)}
        />
      </Portal>
    </>
  )
}

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imgUrl: PropTypes.string.isRequired,
}

export default ProjectCard
